<template>
  <div class="chat-widget-3 " v-if="chatStatus">

    <div class="modal fade" id="chat-widget-3-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="position-relative">
              <m-chat-layout class="m-0 chat-widget-3-form" @startNewChat="startNewChat" :slug="slug"/>
            </div>
          </div>

        </div>
      </div>
    </div>


    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#chat-widget-3-modal" v-t="`chat.chat_widget.buttonText`">

    </button>


  </div>
</template>

<script>
import mChatLayout from "../Layout/ChatLayout1/ChatLayout";
import ChatArchive1 from "../../Chat/Archive/ChatArchive1.vue";
import {mapGetters} from "vuex";
import $ from 'jquery'
export default {
  name: "ChatWidget1",
  components: {ChatArchive1, mChatLayout},
  props: {
    enableAnimation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      slug: null,
      showList: true,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    }),
    chatStatus() {
      return this.findAttributeOnSiteInfo('chat_activity')[0] == 1
    },

  },
  methods: {
    getChatSlugFromLocalStorage() {
      const slug = localStorage.getItem('chat_slug')
      this.slug = slug != undefined ? slug : null
    },
    startNewChat(res) {
      res = res.data.data
      const chatToken = res.chat_token;
      const slug = res.data.slug;
      localStorage.setItem('chat_token', chatToken)
      $('#chat-widget-3-modal').modal('hide')
      this.$router.push({name: "SingleChat", params: {slug: slug}})
    },
    checkChatToken() {
      let chatToken = localStorage.getItem('chat_token')

      if (this.isAuthenticated) {
        return true
      }
      if (chatToken === null) {
        return false
      }

      return true
    }
  },
  mounted() {
    if (this.chatStatus) {
      this.getChatSlugFromLocalStorage()
    }

  }
}
</script>

<style scoped>
.chat-widget-3-form :deep(.fixed-bottom) {
  position: relative;
}
</style>